import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default (props) => {
  const moduleName = `cart_settings`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [minPrice, setMinPrice] = useState(``);
  const [minPriceMessage, setMinPriceMessage] = useState(``);
  const [submitted, setSubmitted] = useState(false);

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.cart_settings_store != undefined && appReducer.cart_settings_store.error == false) ||
        (appReducer.cart_settings_update != undefined && appReducer.cart_settings_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.cart_settings_store,
    appReducer.cart_settings_update
  ])

  useEffect(() => {
    if (appReducer.cart_settings_edit != undefined && id != undefined) {
      let row = appReducer.cart_settings_edit.data;
      setMinPrice(row.min_price);
      setMinPriceMessage(row.min_price_message);
    }
  }, [appReducer.cart_settings_edit]);

  useEffect(() => {
    dispatch(actions.list(`provinces/option`));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <Template.Form>
    <Template.Input
      required
      value={minPrice}
      label="کمینه قیمت  (تومان)"
      name="min_price"
      type="text"
    />
    <Template.Input
      required
      value={minPriceMessage}
      label="پیام کمینه قیمت"
      name="min_price_message"
      type="text"
    />

    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};